<template>
  <v-card class="mt-3">
    <h6 class="subheading py-2 px-3 text-truncate">{{ responsible.name }}</h6>

    <v-list class="py-0">
      <ResponsibleStudent
        v-for="student in responsible.studentsCollection"
        :key="responsible.id+`-`+student.id"
        :student="student"
        @toggleStudent="toggleStudent"
        @options="openOptions"
      />
    </v-list>

    <AbsentStudent
      :isAlreadyAbsent="isAlreadyAbsent"
      :visibility="absentStudentVisibility"
      @confirmAbsent="setAbsentStudentAndHideOptions"
      @confirmPresent="setPresentStudentAndHideOptions"
      @cancel="hideOptions"
    />

  </v-card>
</template>

<script>
import ResponsibleStudent from './ResponsibleStudent'
import AbsentStudent from '@/components/AbsentStudent'
import { mapActions } from 'vuex'

export default {
  name: 'cardAuthorization',

  components: {
    ResponsibleStudent,
    AbsentStudent
  },

  data: () => ({
    absentStudentVisibility: false,
    selectedOptionsStudent: 0,
    isAlreadyAbsent: true
  }),

  props: {
    responsible: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  methods: {
    ...mapActions({
      toggleStudentSelection: 'authorizationInfos/toggleStudentSelection',
      setAbsentStudent: 'authorizationInfos/setAbsentStudent',
      setPresentStudent: 'authorizationInfos/setPresentStudent'
    }),

    toggleStudent ({ id, value }) {
      let responsibleId = this.responsible.id
      let studentId = id
      let payload = { responsibleId, studentId, value }
      this.toggleStudentSelection(payload)
    },

    openOptions ({ id, absent }) {
      this.selectedOptionsStudent = id
      this.isAlreadyAbsent = absent
      this.absentStudentVisibility = true
    },

    hideOptions () {
      this.absentStudentVisibility = false
    },

    setAbsentStudentAndHideOptions () {
      this.hideOptions()
      this.setAbsentStudent(this.selectedOptionsStudent)
    },

    setPresentStudentAndHideOptions () {
      this.hideOptions()
      this.setPresentStudent(this.selectedOptionsStudent)
    }
  }
}
</script>
